import { customTheme } from '../styles';

export const makeSubtitleStyles = (theme) => ({
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 'bold',
  color: theme.palette.text.primary,
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(20),
  },
});

const styles = {
  subtitle: makeSubtitleStyles(customTheme),
  outerMargin: {
    margin: customTheme.spacing(6, 0),
    [customTheme.breakpoints.down('sm')]: {
      margin: customTheme.spacing(4, 0),
    },
  },
  box: {
    border: `1px solid ${customTheme.props.border.secondary.main}`,
    borderRadius: 5,
    marginTop: customTheme.spacing(2),
    padding: customTheme.spacing(3),
  },
};

export default styles;
